


































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { GuideMaterialDataModule } from '@/app/store/modules/quickGuide'
import { GalleryImageModule } from '@/app/store/modules/galleryImage'

@Component({
  name: 'GuideMaterial',
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  private selected = []
  public get isLoading() {
    return GuideMaterialDataModule.isLoading
  }
  public get page() {
    return GuideMaterialDataModule.Pages
  }
  public get limit() {
    return GuideMaterialDataModule.Limit
  }

  public created() {
    GuideMaterialDataModule.paginationParam.search = ''
    GuideMaterialDataModule.paginationParam.filter.category = Number(
      this.$route.params.id
    )
    this.getImage()
    this.getData()
  }
  public getImage() {
    GalleryImageModule.getGalleryImageData()
  }
  public get imageDataCategory() {
    return GalleryImageModule.galleryImageData
  }
  public getData() {
    GuideMaterialDataModule.getGuideMaterialData()
  }

  // Property Top Menu
  private searchInput = ''
  private funcSearch(item) {
    GuideMaterialDataModule.paginationParam.search = item
    this.getData()
  }

  // Property Table
  public get GuideCategoryData() {
    return GuideMaterialDataModule.guideMaterialData
  }
  public fields: any = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'fileCode', sortable: false },
    { key: 'title', sortable: false },
    { key: 'fileName', sortable: false },
    { key: 'recommended', sortable: false },
    { key: 'image', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'expiredDate', sortable: false },
    { key: 'actions', sortable: false },
  ]
  private onRowSelected(items) {
    this.selected = items
  }

  // Property Pagination
  private onPageNumChanged(limit: any) {
    GuideMaterialDataModule.paginationParam.paging.limit = limit
    this.getData()
  }
  private funcFirstPage() {
    GuideMaterialDataModule.paginationParam.paging.page = 1
    this.getData()
  }

  private funcPrevPage() {
    GuideMaterialDataModule.paginationParam.paging.page =
      GuideMaterialDataModule.paginationParam.paging.page - 1
    this.getData()
  }
  private funcNextPage() {
    GuideMaterialDataModule.paginationParam.paging.page =
      GuideMaterialDataModule.paginationParam.paging.page + 1
    this.getData()
  }

  private funcLastPage() {
    GuideMaterialDataModule.paginationParam.paging.page =
      (this.GuideCategoryData.pagination &&
        this.GuideCategoryData.pagination.pageCount) ||
      0
    this.getData()
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
}
